module.exports = __webpack_public_path__ + "media/volvo/assets/images/phone@2x-d1c0d35b8c5815881364e30c0187efaa.png";